import React from "react"
import {
  Form,
  // Select,
  DatePicker,
  Button,
  // Checkbox,
  Row,
  Col,
  Input,
} from "antd"
import { useTranslation } from "react-i18next"
import { useForm } from "antd/lib/form/Form"
import useQueryParams from "../../../hooks/useQueryParams"
import WarehouseSelect from "../../../components/form/WarehouseSelect"
import Modal, { IModalProps } from "../../../components/modal"
import moment from "moment"
// import FactorySelect from "../../../components/form/FactorySelect";
import getDateInterval from "../../../utils/getDateInterval"
import FactorySelect from "../../../components/form/FactorySelect"
import ProductSelect from "../../../components/form/ProductSelect"
import useFilterFormSync from "../../../hooks/useFilterFormSync"   // tog'a #257

interface IFilterModalProps extends IModalProps {
  namedFilter?: boolean
  name?: string
}

export default function FilterModal(props: IFilterModalProps) {
  const { t } = useTranslation()
  const query = useQueryParams()
  const [form] = useForm()

  const filterMatcher = props.namedFilter
    ? `${props.name}filtering`
    : "filtering"
  useFilterFormSync(form, filterMatcher)   // tog'a #257: URL dagi joriy filtrlar formaga

  function handleFinish(values: any) {
    const { begin, end } = getDateInterval(
      values?.interval?.[0],
      values?.interval?.[1]
    )

    delete values.interval

    const cleanValues: Record<string, any> = {}
    const toRemove: string[] = [filterMatcher]

    if (values) {
      Object.keys(values).forEach((key) => {
        const val = values[key]
        if (
          val !== undefined &&
          val !== null &&
          val !== "" &&
          val !== 0 &&
          String(val).trim() !== ""
        ) {
          cleanValues[key] = typeof val === "string" ? val.trim() : val
        } else {
          toRemove.push(key)
        }
      })
    }

    if (begin) cleanValues.begin = begin
    else toRemove.push("begin")

    if (end) cleanValues.end = end
    else toRemove.push("end")

    query.multiple({
      remove: toRemove.join(","),
      set: cleanValues,
    })
  }

  function handleReset() {
    form.resetFields()
    query.removeMany(
      filterMatcher,
      "interval",
      "warehouseFromId",
      "warehouseToId",
      "searchText",
      "search",
      "begin",
      "end"
    )
  }

  return (
    <Modal
      {...props}
      onCancel={() => query.remove(filterMatcher)}
      title={t("filter") || t("filter")}
      footer={null}
    >
      <Form form={form} onFinish={handleFinish} layout="vertical">
        <Row gutter={15}>
          <Col xs={24}>
            <Form.Item name="interval" label={t("interval") || t("period")}>
              <DatePicker.RangePicker
                allowClear
                style={{ width: "100%" }}
                ranges={{
                  [t("today") || t("today")]: [moment(), moment()],
                  [t("thisWeek") || t("thisWeekLbl")]: [
                    moment().startOf("week"),
                    moment().endOf("week"),
                  ],
                  [t("thisMonth") || t("thisMonth")]: [
                    moment().startOf("month"),
                    moment().endOf("month"),
                  ],
                }}
                defaultValue={
                  query.secureGet("begin") && query.secureGet("end")
                    ? [
                        moment(query.secureGet("begin").toString()),
                        moment(query.secureGet("end").toString()),
                      ]
                    : undefined
                }
                format="DD.MM.YYYY"
                size="large"
              />
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item name="warehouseFromId" label={t("oldWarehouseName") || t("fromWarehouseShort")}>
              <WarehouseSelect
                hasEmpty
                defaultValue={+query.secureGet("warehouseFromId") || undefined}
              />
            </Form.Item>
          </Col>
          <Col sm={12} xs={24}>
            <Form.Item name="warehouseToId" label={t("newWarehouseName") || t("toWarehouseShort")}>
              <WarehouseSelect
                hasEmpty
                defaultValue={+query.secureGet("warehouseToId") || undefined}
              />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.Item name="searchText" label={t("searchProductFull")}>
              <Input
                size="large"
                placeholder={t("enterSkuBarcodeName")}
                defaultValue={query.secureGet("searchText")?.toString() || ""}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={15}>
        <Col sm={12} xs={24}>
          <Button
            block
            size="large"
            danger
            onClick={handleReset}
          >
            {t("reset") || t("resetBtn")}
          </Button>
        </Col>
        <Col sm={12} xs={24}>
          <Button
            block
            size="large"
            type="primary"
            onClick={() => form.submit()}
          >
            {t("ok") || t("apply")}
          </Button>
        </Col>
      </Row>
    </Modal>
  )
}
